import { render, staticRenderFns } from "./tiposClientes.vue?vue&type=template&id=f5d1925a&"
import script from "./tiposClientes.vue?vue&type=script&lang=js&"
export * from "./tiposClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports